/* ═══════════════════════════════════════════════════════
   Softline Collection — Full Interactivity
   Sidebar Filters, Range Tabs, Sort, Size Pills, FAQ
═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  const root = document.getElementById('sl-collection');
  if (!root) return;

  const cards = Array.from(root.querySelectorAll('.sc-card'));
  const grid = root.querySelector('.sc-product-grid');
  const countEl = root.querySelector('#sc-product-count');

  /* ── HELPERS ────────────────────────────────────────── */
  function updateCount() {
    const visible = cards.filter(c => c.style.display !== 'none').length;
    if (countEl) countEl.textContent = '(' + visible + ' Product' + (visible !== 1 ? 's' : '') + ' Available)';
  }

  function parsePrice(s) {
    return parseFloat((s || '0').replace(/[^0-9.]/g, '')) || 0;
  }

  /* ── 1. RANGE TABS ─────────────────────────────────── */
  const rangePills = root.querySelectorAll('.sc-range-pill[data-range]');
  let activeRange = 'all';

  rangePills.forEach(pill => {
    pill.addEventListener('click', () => {
      rangePills.forEach(p => p.classList.remove('sc-active'));
      pill.classList.add('sc-active');
      activeRange = pill.dataset.range;
      applyAllFilters();
    });
  });

  /* ── 2. SIDEBAR FILTERS ────────────────────────────── */
  // Toggle filter groups
  root.querySelectorAll('.sc-filter-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.sc-filter-group').classList.toggle('sc-filter-open');
    });
  });

  // Checkbox change
  root.querySelectorAll('.sc-checkbox input[type="checkbox"]').forEach(cb => {
    cb.addEventListener('change', () => applyAllFilters());
  });

  // Clear All
  const clearBtn = root.querySelector('#sc-clear-filters');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      root.querySelectorAll('.sc-checkbox input[type="checkbox"]').forEach(cb => {
        cb.checked = false;
      });
      applyAllFilters();
    });
  }

  /* ── 3. FILTER LOGIC ───────────────────────────────── */
  function getCheckedValues(filterType) {
    const checked = root.querySelectorAll('.sc-checkbox input[data-filter="' + filterType + '"]:checked');
    return Array.from(checked).map(cb => cb.value);
  }

  function applyAllFilters() {
    const priceRanges = getCheckedValues('price');
    const sizes = getCheckedValues('size');
    const comforts = getCheckedValues('comfort');
    const materials = getCheckedValues('material');

    cards.forEach(card => {
      const tags = (card.dataset.tags || '').toLowerCase();
      const cardPrice = parsePrice(card.dataset.price);
      let show = true;

      // Range tab filter
      if (activeRange !== 'all') {
        if (!tags.includes(activeRange)) show = false;
      }

      // Price filter
      if (show && priceRanges.length > 0) {
        let priceMatch = false;
        priceRanges.forEach(range => {
          const parts = range.split('-');
          const min = parseFloat(parts[0]);
          const max = parseFloat(parts[1]);
          if (cardPrice >= min && cardPrice <= max) priceMatch = true;
        });
        if (!priceMatch) show = false;
      }

      // Size filter
      if (show && sizes.length > 0) {
        let sizeMatch = false;
        sizes.forEach(s => { if (tags.includes(s)) sizeMatch = true; });
        if (!sizeMatch) show = false;
      }

      // Comfort filter
      if (show && comforts.length > 0) {
        let comfortMatch = false;
        comforts.forEach(c => { if (tags.includes(c)) comfortMatch = true; });
        if (!comfortMatch) show = false;
      }

      // Material filter
      if (show && materials.length > 0) {
        let matMatch = false;
        materials.forEach(m => { if (tags.includes(m)) matMatch = true; });
        if (!matMatch) show = false;
      }

      card.style.display = show ? '' : 'none';
    });

    updateCount();
  }

  /* ── 4. SORT ───────────────────────────────────────── */
  const sortSelect = root.querySelector('#sc-sort');
  if (sortSelect && grid) {
    sortSelect.addEventListener('change', () => {
      const val = sortSelect.value;
      const sorted = [...cards].sort((a, b) => {
        const pA = parsePrice(a.dataset.price);
        const pB = parsePrice(b.dataset.price);
        const tA = (a.dataset.title || '').toLowerCase();
        const tB = (b.dataset.title || '').toLowerCase();
        if (val === 'price-asc') return pA - pB;
        if (val === 'price-desc') return pB - pA;
        if (val === 'title-asc') return tA.localeCompare(tB);
        return 0;
      });
      sorted.forEach(card => grid.appendChild(card));
    });
  }

  /* ── 5. SIZE PILLS ON CARDS ────────────────────────── */
  root.querySelectorAll('.sc-card').forEach(card => {
    card.querySelectorAll('.sc-size-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        card.querySelectorAll('.sc-size-pill').forEach(p => p.classList.remove('sc-size-active'));
        pill.classList.add('sc-size-active');
      });
    });
  });

  /* ── 6. FAQ ACCORDION ──────────────────────────────── */
  root.querySelectorAll('.sc-faq-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.sc-faq-item');
      const wasOpen = item.classList.contains('sc-open');
      root.querySelectorAll('.sc-faq-item').forEach(i => i.classList.remove('sc-open'));
      if (!wasOpen) item.classList.add('sc-open');
    });
  });

  /* ── 7. MOBILE FILTER DRAWER ───────────────────────── */
  const mobileBtn = root.querySelector('#sc-mobile-filter-btn');
  const sidebar = root.querySelector('#sc-sidebar');
  const overlay = root.querySelector('#sc-filter-overlay');
  const closeBtn = root.querySelector('#sc-close-sidebar');

  function openDrawer() {
    if (sidebar) sidebar.classList.add('sc-sidebar-open');
    if (overlay) overlay.classList.add('sc-show');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (sidebar) sidebar.classList.remove('sc-sidebar-open');
    if (overlay) overlay.classList.remove('sc-show');
    document.body.style.overflow = '';
  }

  if (mobileBtn) mobileBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

})();
